import { render, staticRenderFns } from "./ColumnChartTotalQualities.vue?vue&type=template&id=8340a87c"
import script from "./ColumnChartTotalQualities.vue?vue&type=script&lang=js"
export * from "./ColumnChartTotalQualities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports